import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { XLS_URL } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {

  isDownloadingFile: boolean;

  private basePath: string = ''
  constructor(
    private toastService: ToastService
  ) {
    this.isDownloadingFile = false;
    this.basePath = XLS_URL
  }

  VerifyAndDownload(rutaArchivo: string) {
    if (!rutaArchivo) {
      this.toastService.error('Error al generar archivo')
      return
    }

    const url = `${this.basePath}/${rutaArchivo}`;
    this.isDownloadingFile = true;
    if (_.endsWith(rutaArchivo, 'pdf')) {
      window.open(url, '_blank');
    } else {
      document.location.href = url;
    }
    this.isDownloadingFile = false;
  }

  Download(rutaArchivo: string) {
    this.isDownloadingFile = true;
    document.location.href = `${this.basePath}/${rutaArchivo}`;
    this.isDownloadingFile = false;
  }

  DownloadPDF(rutaArchivo: string) {
    this.isDownloadingFile = true;
    if (rutaArchivo)
      window.open(`${this.basePath}/${rutaArchivo}`);
    else
      this.toastService.error('Error al generar archivo')
    this.isDownloadingFile = false;
  }
}
